import React from 'react';

export default function QuotationAmountToggle({ showAmounts, onToggle, variant = 'standard' }) {
  const buttonClass =
    variant === 'colored'
      ? 'px-4 py-2 bg-gradient-to-r from-sky-400 to-indigo-400 text-white rounded-lg hover:from-sky-500 hover:to-indigo-500 transition-all text-sm font-medium shadow-sm'
      : 'px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-sm font-medium';

  return (
    <div className="mb-2 print:hidden">
      <button type="button" onClick={onToggle} className={buttonClass}>
        {showAmounts ? 'Hide Amounts' : 'Show Amounts'}
      </button>
    </div>
  );
}
